import HeaderModern, { DEFAULT_HEADER_MODERN } from '../../header-variants/HeaderModern';
import HeaderClassic                           from '../../header-variants/HeaderClassic';

const VARIANTS = { modern: HeaderModern, classic: HeaderClassic };

export default function Header({ cartCount = 0, isLoggedIn = false }) {
  const td = window.themeData ?? {};
  const ts = td.themeSettings  ?? {};
  const hs = td.headerSettings ?? {};

  const activeVariant = ts.activeHeader ?? hs.variant ?? 'modern';
  const Component     = VARIANTS[activeVariant] ?? HeaderModern;
  const settings      = Object.keys(hs).length ? hs : DEFAULT_HEADER_MODERN;

  return <Component settings={settings} cartCount={cartCount} isLoggedIn={isLoggedIn} />;
}
